import { LogistikComponentShippingDetails } from '@chancenlogistik/client/components/logistik-component-shipping-details.js';
import { LogistikShippingRecipient } from '@chancenwerk/db/enums/LogistikEnums.js';
import { LogistikSchoolAccessToken } from '@chancenwerk/db/tokens.js';
import type { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import { PartnerPublicInformationAPI } from '@chancenwerk/public-access/api/PartnerPublicInformationAPI.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { activeToken } from '../globalSubjects.js';

/**
 * @element hefte-component-shipping-details
 */
@customElement('hefte-component-shipping-details')
export class HefteComponentShippingDetails extends LogistikComponentShippingDetails {
  override connectedCallback(): void {
    super.connectedCallback();

    this.disabledFormFields.next({ shippingSchoolID: 1 });

    // prefill alternative shipping address if external access was granted
    if (activeToken.getValue())
      void LogistikSchoolAccessToken.getByToken<LogistikSchoolAccessToken>(+activeToken.getValue())(
        LogistikSchoolAccessToken.allFields,
      ).then(token => {
        if (
          token &&
          this.value.value &&
          (token.zuHaenden || token.schoolAddress?.hausnummer || token.schoolAddress?.strasse)
        ) {
          this.value.value.shippingRecipient = LogistikShippingRecipient.SCHOOL;
          this.value.value.shippingRecipientName = token.schoolName ?? '';
          this.value.value.shippingRecipientzuHaenden = token.zuHaenden;
          this.value.value.shippingAddress = token.schoolAddress;
        }
        if (token.schoolID)
          void PartnerPublicInformationAPI.getByID([token.schoolID])({
            _id: 1,
            _class: 1,
            name: 1,
            address: {
              _class: 1,
              strasse: 1,
              country: 1,
              hausnummer: 1,
              zipCity: {
                _class: 1,
                zip: 1,
                city: 1,
              },
            },
            bundesland: 1,
            hideOnWebsite: 1,
          }).then(schools => {
            if (this._form.document) this._form.document.shippingSchoolID = token.schoolID;
            if (schools[0]) this._selectedSchool.next(schools[0]);
          });
      });
  }

  protected override _schoolPicker() {
    return html`
      <chancen-component-public-school-id-picker
        ${this._form.field('shippingSchoolID')}
        placeholder="Standort"
        emptyState="Keine Standorte gefunden"
        error=${ifDefined(this._errorMsg.value?.includes('Standort') ? this._errorMsg.value : undefined)}
      ></chancen-component-public-school-id-picker>
    `;
  }

  protected override _kpfFilter(kpf: KPF) {
    return kpf.produkt?.name?.toLowerCase() === 'chancenhefte';
  }
}
